import React, { ReactNode } from 'react';
import { useDispatch, useSelector } from "react-redux";
import { OperationProvider } from "../../../contexts/OperationContext";
import { VesselSideService } from '../../../util/services/vessel-side';
import { selectOverview, selectTenantId } from "../../../util/store/selectors";
import { OP_STATUS, OPERATION_TYPE } from '../../../util/varibles/constants';
import { getElById, showErrorResponse } from '../../../util/varibles/global';
import { ILevelByOp, IOperation, IOperation2, IOperations, IVessel } from "../../../util/varibles/interface";
import { notify } from '../../../util/varibles/message';
import { template, TemplateCode } from '../../../util/varibles/template';
import { loginActions } from '../../LoginPage/reducer';
import Operation from "../../PlanOperationPage/Plan/Calendar/Operations/Operation";
import { generate } from '../../PlanOperationPage/util';
import { overviewActions } from '../reducer';

interface IProps {
    vesselIndex: number
    vessel: IVessel
    width: number
    level?: ILevelByOp
    operations?: IOperations
    allowEdit?: boolean
    ignoreUnavailable?: boolean
}

const Operations: React.FC<IProps> = ({
    level = {},
    vessel,
    width,
    vesselIndex,
    operations: operationsProp,
    allowEdit = true,
    ...args
}) => {
    const overviewOperations = useSelector(selectOverview.ops);
    const operations = operationsProp || overviewOperations;
    const userTenantId = useSelector(selectTenantId);
    const dispatch = useDispatch();

    const handeSave = (op: IOperation) => {
        const { id } = op.operation;
        const vessels = [
            {
                vessel_id: op.vessel.id,
                vessel_owner_id: op.vessel.tenant_id,
                operations: [generate(op as IOperation2, { status: op.operation.status })]
            }
        ]
        const el = getElById(id + '-loading');
        if (el) {
            el.dataset.loading = "true";
        }
        VesselSideService.crewSend({ vessels })
            .then((rs: any) => {
                const { new_operations, old_operations } = rs;
                const { vessel } = op;

                const { newCode, newOps } = new_operations.reduce((rs: any, item: any) => {
                    rs.newCode = [...rs.newCode, `#${item.operation.operation_code}`];
                    rs.newOps = [...rs.newOps, { ...item, vessel }];
                    return rs;
                }, { newCode: [], newOps: [] });

                const { oldCode, oldOps } = old_operations.reduce((rs: { oldCode: string[], oldOps: IOperation[] }, item: IOperation) => {
                    rs.oldCode = [...rs.oldCode || [], `#${item.operation.operation_code}`];
                    rs.oldOps = [...rs.oldOps || [], { ...item, vessel }];
                    return rs;
                }, { oldCode: [], oldOps: [] });

                notify.success({
                    message: 'Update successfully',
                    description: template[TemplateCode.T2]('', newCode, oldCode)
                });
                dispatch(overviewActions.addOps(newOps))
                dispatch(overviewActions.updateOps(oldOps))
                dispatch(loginActions.updateOpsOfVessel([...newOps, ...oldOps]));
                if (el) {
                    delete el.dataset.loading;
                }
            })
            .catch(error => {
                showErrorResponse('Update failed', error)
                if (el) {
                    delete el.dataset.loading;
                }
            })
    }

    return <>
        {Object.keys(level).reduce((rs: ReactNode[], key) => {
            const item = operations[key] || {};

            if (!item?.operation)
                return rs;

            const { id, tenant_id, operation_type, status } = item.operation || {};
            const isOwn = tenant_id === userTenantId;
            const isEdit = (status !== OP_STATUS.PROCESSING && operation_type === OPERATION_TYPE.EVENT) || operation_type === OPERATION_TYPE.SERVICE;
            return [...rs, <OperationProvider
                key={item.operation.id}
                isOwn={isOwn}
                isDrag={allowEdit && isOwn && isEdit}
                data={item}
                vesselIndex={vesselIndex}
                width={width}
                level={level[id]}
                getVessels={() => [{ ...vessel, isShow: true }]}
                getOps={() => operations}
                updateOp={value => handeSave({ ...item, ...value })}
                canEditTimeline={allowEdit && isEdit}
            >
                <Operation {...args} data={item} isOwn={isOwn} readOnly={!allowEdit} />
            </OperationProvider>]
        }, [])}
    </>;
};

export default Operations;
